/* eslint-disable */
import { CSSProperties } from 'react'
import { userFeedbackTableConfig } from '../configs'
import { FeedbackConfigFieldNames } from 'tabs/nlp/components/UserFeedback/types'

export const userFeedbackTableRowConfigs: Record<FeedbackConfigFieldNames, CSSProperties> = {
  userQuestion: {
    maxWidth: userFeedbackTableConfig.userQuestion.maxWidth,
  },
  botAnswer: {
    maxWidth: userFeedbackTableConfig.botAnswer.maxWidth,
  },
  userFeedback: {
    maxWidth: userFeedbackTableConfig.userFeedback.maxWidth,
  },
  type: {
    maxWidth: userFeedbackTableConfig.type.maxWidth,
    textAlign: 'center',
  },
  solveButton: {
    maxWidth: userFeedbackTableConfig.solveButton.maxWidth,
  },
  createdAt: { maxWidth: userFeedbackTableConfig.createdAt.maxWidth },
  removeButton: {
    maxWidth: userFeedbackTableConfig.removeButton.maxWidth,
  },
}

export const userFeedbackTableRemoveConfig = {
  title: 'Remove User Feedback?',
  content: `Are you sure you want to remove this user feedback? Once you've done it, you won't be able to revert the changes.`,
}
